import { AgreementProvider } from "@sb1finans/components/dist/AgreementContext";
import { default as useApiContext, ApiProvider } from "@sb1finans/components/dist/ApiProvider";
import React, { Component, FC } from "react";
import { AccountProvider } from "./AccountProvider";
import { OrderProvider } from "./OrderProvider"

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { UserContextProvider } from "@sb1finans/components/dist/UserContext";
import { AxiosError } from "axios";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

/**
 * This is the main app provider. It provides all the context providers that are needed for the app.
 */
interface AppProviderProps {
    children: React.ReactNode
    config: any
}

export const AppProvider: React.FC<AppProviderProps> = ({ children, config }) => {
    return (
        <ApiProvider config={config}>
            <AppWrapper config={config}>
                {children}
                </AppWrapper>
            </ApiProvider>
    )
}

interface AppWrapperProps {
    config: any
}

const AppWrapper: React.FC<AppWrapperProps> = ({children, config}) => {
    const {vendorsApi, error} = useApiContext()
    const shouldShowError = error instanceof AxiosError && (error.response?.status === 403 || error.response?.status === 401)

    return (
        <>
                <AgreementProvider vendorsApi={vendorsApi}>
                    {children}
                </AgreementProvider>
            {<ErrorDialog open={shouldShowError} loginUrl={config.loginUrl} />}
        </>
    )
}

interface ErrorDialogProps {
    open: boolean,
    loginUrl: string
}
const ErrorDialog: FC<ErrorDialogProps> = ({open, loginUrl}) => {
  
    const handleClose = () => {
        console.info("Close")
        window.location.href = `${loginUrl}?redirectUri=${window.location.origin}&acr_values=urn:sb1finans:oidc:method:bankid`
    };

    return (
        <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Sesjonen er utløpt"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sesjonen er utløpt eller ugyldig. Du vil bli sendt til innloggingssiden.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    )
}
   